import { action } from "mobx";
import { BaseShuffleEditViewStore } from "administration/shuffle/stores";
import { MrbSelectStore } from "mrb/components/select";
import { UUID } from "common/utils";
import { findIndex, head, map } from "lodash";

class NakiNigunShuffleEditViewStore extends BaseShuffleEditViewStore {
    constructor(rootStore, componentProps) {
        super(rootStore, componentProps);

        this.shuffleItemSelectStore = new MrbSelectStore({
            isSearchable: true,
            textKey: "title",
            valueKey: "id",
            initFetch: false,
            actions: {
                find: (searchTerm, pageNumber, pageSize) => {
                    const selectedIds = map(this.items, (item) => item.nakiNigunAlbum.id);
                    return this.routeStore.findShufflableNakiNigunAlbum({
                        search: searchTerm,
                        orderBy: "title",
                        orderDirection: "asc",
                        fields: "id,title,isPremium,artist",
                        embed: "artist",
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        excludeIds: selectedIds.length > 0 ? selectedIds : null,
                    });
                },
                mapItem: (item) => {
                    return {
                        label: `${item.artist.name} - ${item.title}`,
                        value: item.id,
                        item: item,
                    };
                },
            },
        });
    }

    get(id) {
        return this.routeStore.getNakiNigunAlbumShuffle(id);
    }

    create(data) {
        return this.routeStore.createNakiNigunAlbumShuffle(data);
    }

    update(data) {
        return this.routeStore.updateNakiNigunAlbumShuffle(data);
    }

    @action.bound
    addNakiNigunAlbumShuffleItem() {
        const nakiNigunAlbum = this.shuffleItemSelectStore.selectedItem;
        const obj = {
            id: UUID.create(),
            nakiNigunAlbumId: nakiNigunAlbum.id,
            nakiNigunAlbum: nakiNigunAlbum,
            shuffleWeightId: head(this.shuffleWeights).id,
        };
        if (this.itemExists(obj.nakiNigunAlbumId)) {
            return;
        }
        this.addShuffleItem(obj);
        this.shuffleItemSelectStore.clearOptions();
        this.shuffleItemSelectStore.filter();
    }

    itemExists(itemId) {
        return findIndex(this.items, (item) => item.nakiNigunAlbumId === itemId) !== -1;
    }
}

export default NakiNigunShuffleEditViewStore;
